const plain = (value) => value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
/** A mensagem chama o Secretário? Vale o nome (ou "secretário") no começo, ou @nome. */
export function callsSecretary(text, secretaryName) {
    const name = plain(secretaryName).trim();
    const words = plain(text)
        .split(/[^a-z0-9@]+/)
        .filter(Boolean);
    const names = new Set(['secretario', 'secretaria', ...(name ? [name.split(/\s+/)[0]] : [])]);
    if (words.some((word) => word.startsWith('@') && names.has(word.slice(1))))
        return true;
    return words.slice(0, 3).some((word) => names.has(word));
}
export function proxyReplyPayload(fields) {
    return JSON.stringify([
        'sec-reply-v1',
        fields.kid,
        fields.roomId,
        fields.eventId,
        fields.owner,
        fields.proxy,
        fields.incomingHash,
        fields.bodyHash,
        fields.name,
        fields.characterKey,
        fields.ownerName,
        fields.iat,
    ]);
}
/** Texto como entra na conta do resumo (o mesmo corte que o servidor aplica). */
export function proxyHashInput(text) {
    return text.trim().slice(0, 2000);
}
